import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=74cd0a03&"
import script from "./Activity.vue?vue&type=script&lang=js&"
export * from "./Activity.vue?vue&type=script&lang=js&"
import style0 from "./Activity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cd0a03')) {
      api.createRecord('74cd0a03', component.options)
    } else {
      api.reload('74cd0a03', component.options)
    }
    module.hot.accept("./Activity.vue?vue&type=template&id=74cd0a03&", function () {
      api.rerender('74cd0a03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/activities/Activity.vue"
export default component.exports